"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _core = require("@material-ui/core");

var _Modal = require("../../Modal");

var _Button = _interopRequireDefault(require("../../../atoms/Button"));

var _tokens = _interopRequireDefault(require("../../../tokens"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CustomizedModalFooter = /*#__PURE__*/(0, _styledComponents["default"])(_Modal.ModalFooter).withConfig({
  displayName: "DialogFooter__CustomizedModalFooter"
})(["", ""], function (_ref) {
  var typography = _ref.theme.typography;
  return (0, _styledComponents.css)(["padding:", " ", ";border-radius:0 0 ", "px ", "px;"], typography.pxToRem(12), typography.pxToRem(16), _tokens["default"].borderRadius, _tokens["default"].borderRadius);
});

var DialogFooter = function DialogFooter(_ref2) {
  var buttons = _ref2.buttons;

  var _ref3 = buttons.length > 1 ? ['medium', 6] : ['large', 12],
      _ref4 = _slicedToArray(_ref3, 2),
      buttonSize = _ref4[0],
      xs = _ref4[1];

  var buttonsGrid = (0, _react.useMemo)(function () {
    return buttons.map(function (button, index) {
      return _react["default"].createElement(_core.Grid, {
        item: true,
        xs: xs,
        key: index
      }, _react["default"].createElement(_Button["default"], {
        key: index,
        color: button.color,
        size: buttonSize,
        variant: button.variant,
        onClick: button.callback
      }, button.label));
    });
  }, [buttons]);
  return _react["default"].createElement(CustomizedModalFooter, null, _react["default"].createElement(_core.Grid, {
    container: true
  }, buttonsGrid));
};

var _default = DialogFooter;
exports["default"] = _default;